// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  register: path(ROOTS_AUTH, '/register'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  verify: path(ROOTS_AUTH, '/verify'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  newPassword: path(ROOTS_AUTH, '/new-password'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  OutreachStats: '/outreach-stats',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  permissionDenied: path(ROOTS_DASHBOARD, '/permission-denied'),
  blank: path(ROOTS_DASHBOARD, '/blank'),
  general: {
    home: path(ROOTS_DASHBOARD, '/home'),
    projects: path(ROOTS_DASHBOARD, '/projects'),
    reports: path(ROOTS_DASHBOARD, '/reports'),
    canvassing: path(ROOTS_DASHBOARD, '/canvassing'),
    admin: path(ROOTS_DASHBOARD, '/admin'),
  },
  // reports: {
  //   root: path(ROOTS_DASHBOARD, '/reports'),
  //   team: path(ROOTS_DASHBOARD, '/reports/team'),
  //   polling: path(ROOTS_DASHBOARD, '/reports/polling'),
  //   canvassing: path(ROOTS_DASHBOARD, '/reports/canvassing'),
  //   calling: path(ROOTS_DASHBOARD, '/reports/calling'),
  //   texting: path(ROOTS_DASHBOARD, '/reports/texting'),
  // },
  conversations: {
    root: path(ROOTS_DASHBOARD, '/conversations'),
  },
  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
    alerts: path(ROOTS_DASHBOARD, '/settings#alerts'),
    billing: path(ROOTS_DASHBOARD, '/settings#billing'),
    organization: path(ROOTS_DASHBOARD, '/settings#organization'),
    team: path(ROOTS_DASHBOARD, '/team'),
    creation: path(ROOTS_DASHBOARD, '/settings/organization/creation'),
    update: path(ROOTS_DASHBOARD, '/settings/organization/update'),
    vfupdate: path(ROOTS_DASHBOARD, '/settings/vf-updates'),
  },
  campaigns: {
    root: path(ROOTS_DASHBOARD, '/campaigns'),
    edit: (id: string) => path(ROOTS_DASHBOARD, `/campaigns/${id}`),
  },
  lists: {
    root: path(ROOTS_DASHBOARD, '/lists'),
    editList: (name: string) => path(ROOTS_DASHBOARD, `/lists/${name}`),
  },
  crm: {
    root: path(ROOTS_DASHBOARD, '/crm/contacts'),
    contacts: path(ROOTS_DASHBOARD, '/crm/contacts'),
  },
  data: {
    root: path(ROOTS_DASHBOARD, '/data'),
    tags: path(ROOTS_DASHBOARD, '/data/tags'),
    // editTag: (name: string) => path(ROOTS_DASHBOARD, `/data/tags/${name}`),
    models: path(ROOTS_DASHBOARD, '/data/models'),
    // editModels: (name: string) => path(ROOTS_DASHBOARD, `/data/models/${name}`),
    upload: path(ROOTS_DASHBOARD, '/data/upload'),
    exports: path(ROOTS_DASHBOARD, '/data/exports'),
  },
  messaging: {
    root: path(ROOTS_DASHBOARD, '/messaging'),
    editSurvey: (name: string) => path(ROOTS_DASHBOARD, `/messaging/surveys/${name}`),
    editConditionalSurvey: (id: string) =>
      path(ROOTS_DASHBOARD, `/messaging/conditional-surveys/${id}`),
    editConditionalText: (id: string) =>
      path(ROOTS_DASHBOARD, `/messaging/conditional-texts/${id}`),
    editText: (name: string) => path(ROOTS_DASHBOARD, `/messaging/texts/${name}`),
    editVoicemail: (name: string) => path(ROOTS_DASHBOARD, `/messaging/voicemails/${name}`),
  },
  // user: {
  //   root: path(ROOTS_DASHBOARD, '/user'),
  // },
};

export const PATH_DOCS = {
  root: 'https://intercom.help/numinar/en/',
};
